import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductoService } from 'src/app/services/producto.service';
import { GLOBAL } from 'src/app/services/global';
import { FollowService } from 'src/app/services/follow.service';
import { MetricaService } from 'src/app/services/metrica.service';
import { Router } from '@angular/router';
import { FabricanteService } from 'src/app/services/fabricante.service';

@Component({
  selector: 'app-pagina-marca',
  templateUrl: './pagina-marca.component.html',
  styleUrls: ['./pagina-marca.component.css']
})
export class PaginaMarcaComponent implements OnInit {

  tipo: string;
  slug: string;
  producto: any;
  fabricante: any;
  pantallaCargada: boolean = false;
  url: string;
  seccion: string;
  userLogin: any;
  follow: boolean;
  follows: number;
  visualizaciones: number;
  carrito: any = null;
  hayCarrito: boolean = false;

  @ViewChild("btnLike", null) btnLike: { nativeElement: any; }
  
  constructor(private route: ActivatedRoute, 
    private pService: ProductoService,
    private filService: FollowService,
    private router: Router,
    private mService: MetricaService,
    private fService: FollowService,
    private fFabricanteService: FabricanteService
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.url = GLOBAL.url;
    this.userLogin = JSON.parse(localStorage.getItem("user"));

    this.route.params.subscribe(result => {
      this.tipo = this.route.snapshot.data['tipo'];
      this.seccion = this.route.snapshot.data['seccion'];
      this.slug = result.slug;

      if(this.tipo == 'producto'){
        this.seccion = 'producto';
        this.getInfoProducto(this.slug);
      }

      if(this.tipo == 'marca'){
        this.getInfoMarca(this.slug);
      }
    });

  }

  onIrAProducto(producto: any): void {
    window.scrollTo(0, 0);
    this.producto = producto;
    this.tipo = 'producto';
    this.slug = producto.slug;
    this.seccion = 'producto';
  }

  getInfoProducto(slug: string){
    this.pService.getInfoProductoBySlug(slug).subscribe(result => {
      this.producto = result;
      this.fabricante = result.fabricante;
      console.log(this.fabricante);
      this.visualizaciones = result.visualizaciones;
      this.getFollow();
      this.getTotalSeguidores();
      this.addMetrica(1);
      this.pantallaCargada = true;
    });
  }

  getInfoMarca(slug: string){
    this.fFabricanteService.getInfoFabricanteBySlug(slug).subscribe(result => {
      this.fabricante = result;
      this.visualizaciones = result.visualizaciones;
      this.getFollow();
      this.getTotalSeguidores();
      this.pantallaCargada = true;

      if(this.seccion == 'info'){
        this.addMetrica(6);
        this.visualizaciones = result.visualizaciones_info;
      }

      if(this.seccion == 'tienda'){
        this.addMetrica(5);
        this.visualizaciones = result.visualizaciones_productos;
      }
    });
  }

  onClickSelectSeccion(seccion: string){
    window.scrollTo(0, 0);
    this.seccion = seccion;

    if(this.seccion == 'info'){
      this.tipo = 'marca';
      this.addMetrica(6);
    }

    if(this.seccion == 'tienda'){
      this.tipo = 'marca';
      this.addMetrica(5);
      const carrito = JSON.parse(localStorage.getItem("carrito"));
      this.hayCarrito = carrito != null && typeof carrito === 'object' && Object.keys(carrito).length > 0;
    }

    if(this.seccion == 'producto'){
      this.tipo = 'producto';
    }
  }

  getFollow(){
    if(this.userLogin != null){
      if(this.tipo == 'producto'){
        this.filService.comprobarFollowProd(this.producto.id, this.userLogin.id).subscribe(resultado => {
          if (resultado.result == 'si') {
            this.follow = true;
          }
          if (resultado.result == 'no') {
            this.follow = false;
          }
        });
      } else {
        this.filService.comprobarFollowMarca(this.fabricante.id, this.userLogin.id).subscribe(resultado => {
          if (resultado.result == 'si') {
            this.follow = true;
          }
          if (resultado.result == 'no') {
            this.follow = false;
          }
        });
      }
    } else {
      this.follow = false;
    }
  }

  addMetrica(tipo_interaccion) {

    let producto_id = null;

    if(this.tipo == 'producto'){
      producto_id = this.producto.id;
    }

    let modeloMetrica = {
      producto_id: producto_id,
      fabricante_id: this.fabricante.id,
      tipo_interaccion: tipo_interaccion
    }

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Metrica guardada");
      } else {
        console.log("Error a la hora de guardar en metrica");
      }
    });

  }

  onClickLike() {

    if (this.userLogin == null) {
      this.router.navigate(['registrarse'], { queryParams: { marcaFicha: this.producto.nombre } });
    } else {
      if(this.tipo == 'producto'){
      this.fService.setSeguidorProducto(this.producto.id, this.userLogin.id).subscribe(result => {
        let resultInsertFollow = result;

        if (resultInsertFollow.result == "ok") {
          this.follow = true;
          $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Producto guardado');
          $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
        }

        if (resultInsertFollow.result == "delete") {
          this.follow = false;
          $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Guardar producto');
          $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
        }

        this.getTotalSeguidores();
      });
      } else {
        this.fService.setSeguidorFabricante(this.fabricante.id, this.userLogin.id).subscribe(result => {
          let resultInsertFollow = result;
          if (resultInsertFollow.result == "ok") {
            this.follow = true;
            $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Marca guardada');
            $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
          }
          if (resultInsertFollow.result == "delete") {
            this.follow = false;
            $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Guardar marca');
            $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
          }
          this.getTotalSeguidores();
        });
      }
    }

  }

  getTotalSeguidores = () => {

    if(this.tipo == 'producto'){
      this.fService.getTotalSeguidoresProductos(this.producto.slug).subscribe(result2 => {
        this.follows = result2;
      });
    } else {
      this.fService.getTotalSeguidoresFabricante(this.fabricante.id).subscribe(result2 => {
        this.follows = result2;
      });
    }
  }

  clickIrA() {

    const url = `https://www.google.com/maps/dir/?api=1&destination=${this.fabricante.lat},${this.fabricante.lng}&travelmode=walking`;
    window.open(url, '_blank');
  }

  onCarritoActualizado(tieneItems: boolean): void {
    this.hayCarrito = tieneItems;
  }

  onClickContacto(){

      let mensaje = this.fabricante.boton_contacto_mensaje == null ? '' : this.fabricante.boton_contacto_mensaje;

      const urlWhatsApp = `https://wa.me/${this.fabricante.boton_contacto_telefono}?text=${encodeURIComponent(mensaje)}`;
      console.log(urlWhatsApp);
      window.open(urlWhatsApp, '_blank');
    
  }

}
